/* ============
 * Package Unit Type Transformer
 * ============
 *
 * The transformer for the packageUnitTypes.
 */

import Transformer from './transformer';

export default class packageUnitTypeTransformer extends Transformer {

  static fetch(packageUnitTypes) {
    return {
      id: packageUnitTypes.id,
      name: packageUnitTypes.name,
    };
  }

  static send(packageUnitTypes) {
    return {
      id: packageUnitTypes.id,
      name: packageUnitTypes.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/packageUnitType.js